export type ScoreTier = "strong" | "watch" | "concern";

/** Explicit hex / rgba — not Tailwind semantic palette tokens */
export const SCORE_TIER_COLORS: Record<
  ScoreTier,
  { text: string; bar: string; track: string }
> = {
  strong: {
    text: "#00C389",
    bar: "#00E5A8",
    track: "rgba(0, 229, 168, 0.18)",
  },
  watch: {
    text: "#E8940A",
    bar: "#FFB020",
    track: "rgba(255, 176, 32, 0.22)",
  },
  concern: {
    text: "#E8174A",
    bar: "#FF3D6E",
    track: "rgba(255, 61, 110, 0.18)",
  },
};

export function scoreTier(score: number): ScoreTier {
  if (score >= 80) return "strong";
  if (score >= 60) return "watch";
  return "concern";
}

export function scoreColors(score: number) {
  return SCORE_TIER_COLORS[scoreTier(score)];
}

export function riskScoreLabel(score: number): string {
  if (score >= 80) return "Strong";
  if (score >= 60) return "Watch";
  return "Concern";
}
